(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header-slideshow"] && !window.DesignMode) return;
  try {
    
var initHeaderSlideshow = function(slideshowElement) {
  slideshowElement.flexslider({
    controlNav: false, // Removes bottom navigation buttons
    directionNav: true, // Enables left/right navigation arrows
    slideshowSpeed: 7000, // 7 seconds per slide
  });
};

// Initial setup
initHeaderSlideshow($('.header-slideshow'));

// Handle section unload
$(document).on('shopify:section:unload', function(event) {
  var target = $(event.target);
  target.find('.header-slideshow').flexslider('destroy');
});

// Handle section load
$(document).on('shopify:section:load', function(event) {
  initHeaderSlideshow($(event.target).find('.header-slideshow'));
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-slideshow"] && !window.DesignMode) return;
  try {
    
var initHeaderSlideshow = function(slideshowElement) {
  slideshowElement.flexslider({
    controlNav: false, // Removes bottom navigation buttons
    directionNav: true, // Enables left/right navigation arrows
    slideshowSpeed: 7000, // 7 seconds per slide
  });
};

// Initial setup
initHeaderSlideshow($('.header-slideshow'));

// Handle section unload
$(document).on('shopify:section:unload', function(event) {
  var target = $(event.target);
  target.find('.header-slideshow').flexslider('destroy');
});

// Handle section load
$(document).on('shopify:section:load', function(event) {
  initHeaderSlideshow($(event.target).find('.header-slideshow'));
});


  } catch(e) { console.error(e); }
})();
      })();
